import React from 'react'
import YouTube from 'react-youtube';
import { Helmet } from 'react-helmet';
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import './section-radio-show-and-forum-video-and-comments.scss'

const SectionRadioShowAndForumVideoAndComments = ({ contentInfo }) => {

    // const [pageLoad, setPageLoad] = useState(false);
    const { homeLink } = useHomeLinkMode();
    // useEffect(() => {
    //     setPageLoad(true)
    // }, []);

    const optionsVideo = {
        height: '100%',
        width: '100%',
    };

    const videoID = contentInfo.redireccionBoton !== null ? contentInfo.redireccionBoton.split('/')[contentInfo.redireccionBoton.split('/').length - 1] : null;
    const secondId = contentInfo.redireccionBoton !== null ? (videoID.includes("watch") ? videoID.split('=')[1] : videoID) : null

    return (
        <section className="f-m-radio-show-and-forum-video-and-comments">
            <div id="fb-root"></div>
            <Helmet>
                <script async defer crossorigin="anonymous" src={"https://connect.facebook.net/es_ES/sdk.js#xfbml=1&version=v12.0"} nonce="EynqvXxo"></script>
            </Helmet>
            <div className="f-m-radio-show-and-forum-video-and-comments__content">
                <div className="f-m-radio-show-and-forum-video-and-comments__background"></div>
                <div className="f-m-radio-show-and-forum-video-and-comments__video-container">
                    {contentInfo.redireccionBoton !== null &&
                        <YouTube
                            videoId={secondId}
                            opts={optionsVideo}
                            containerClassName="f-m-radio-show-and-forum-video-and-comments__video"
                        />
                    }
                </div>
                <div className="f-m-radio-show-and-forum-video-and-comments__facebook">
                    <div className="fb-comments" data-href={homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "curso-de-cuidadores/") + "programa-en-vivo/"} data-width="100%" data-numposts="5"></div>
                </div>
            </div>
        </section>
    )
}

export default SectionRadioShowAndForumVideoAndComments
